import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { Amplify } from "aws-amplify";
import config from "./amplifyconfiguration.json";
import apiConfig from "./aws-sync-exports-auth.json";
import { initRum } from "./utils/rum";

const awsConfig = Object.assign(config, apiConfig);
Amplify.configure(awsConfig);
initRum();

// ▼ RUM ソースマップ逆難読化の検証用（一時。確認後に削除）
if (new URLSearchParams(window.location.search).get("rum_test") === "1") {
  setTimeout(() => {
    throw new Error("RUM sourcemap verification — intentional test error");
  }, 0);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
